import { Workspace } from "@/domain/workspace/models/workspace-model";

import { TeamWithoutMembershipList } from "../models/team-model";

export const makeTeamUrl = ({ workspace, team, path }: { workspace: Workspace; team: TeamWithoutMembershipList; path: string }) => {
  return `/${workspace.workspaceUrl}/teams/${team.id}/${path}`;
};

export const makeSharedTeamUrl = ({ workspace, team, path }: { workspace: Workspace; team: TeamWithoutMembershipList; path: string }) => {
  return `/${workspace.workspaceUrl}/shared-teams/${team.id}/${path}`;
};

export type TeamUrlBuilder = typeof makeTeamUrl;

export const makeTeamSettingsUrl = ({ workspace, team, path }: { workspace: Workspace; team: TeamWithoutMembershipList; path: string }) => {
  return `/${workspace.workspaceUrl}/settings/teams/${team.id}/${path}`;
};
